import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=5f871b19&module=true&lang=css"
cssModules["$style"] = style0
import "./Header.vue?vue&type=style&index=1&id=5f871b19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-5f871b19"]])

export default __exports__